import React, { useState } from 'react';
import {
  Button,
  Input,
  InputNumber,
  Space,
  Typography,
  message,
  Card,
  Table,
  Tag,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import { adminExclusivePoolVoiceTest, adminExclusivePoolVoiceTestCallsToday } from '../../api';

const { Text, Paragraph } = Typography;

const voiceAnswerTagColor = (status) => {
  if (status === 'answered') return 'success';
  if (status === 'send_failed' || status === 'query_error') return 'error';
  if (status === 'unanswered') return 'warning';
  return 'default';
};

const ExclusivePoolVoiceTest = () => {
  const [calledShowNumber, setCalledShowNumber] = useState('');
  const [phone, setPhone] = useState('');
  const [houseName, setHouseName] = useState('');
  const [roomFang, setRoomFang] = useState('');
  const [amount, setAmount] = useState(10);
  const [sendLoading, setSendLoading] = useState(false);
  const [queryLoading, setQueryLoading] = useState(false);
  const [list, setList] = useState([]);
  const [queryMsg, setQueryMsg] = useState('');

  const loadToday = async (phoneOverride) => {
    const p = String(phoneOverride ?? phone ?? '').trim();
    if (!p) {
      message.warning('请先输入手机号');
      return;
    }
    setQueryLoading(true);
    try {
      const res = await adminExclusivePoolVoiceTestCallsToday(p);
      if (res?.success) {
        setList(Array.isArray(res.data?.list) ? res.data.list : []);
        setQueryMsg(res.msg || '');
      } else {
        setList([]);
        message.error(res?.msg || '查询失败');
      }
    } catch (e) {
      setList([]);
      message.error(e.response?.data?.msg || e.message || '查询失败');
    } finally {
      setQueryLoading(false);
    }
  };

  const sendTest = async () => {
    const show = String(calledShowNumber || '').trim();
    if (!show) {
      message.warning('请输入专属外显号码');
      return;
    }
    const p = String(phone || '').trim();
    if (!p) {
      message.warning('请输入手机号');
      return;
    }
    setSendLoading(true);
    try {
      const res = await adminExclusivePoolVoiceTest({
        called_show_number: show,
        phone: p,
        house_name: String(houseName || '').trim(),
        room_fang: String(roomFang || '').trim(),
        amount: amount != null ? amount : 0,
      });
      if (res?.success) {
        message.success(res.msg || `已发起外呼，外显 ${show}`);
        await loadToday(p);
      } else {
        message.error(res?.msg || '外呼失败');
        await loadToday(p);
      }
    } catch (e) {
      message.error(e.response?.data?.msg || e.message || '外呼失败');
    } finally {
      setSendLoading(false);
    }
  };

  return (
    <div>
      <PageTitle title="专属号池语音测试" />

      <Card title="发起测试外呼（专属外显）" size="small" style={{ marginBottom: 16, maxWidth: 720 }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text type="secondary">专属外显号码</Text>
            <Input
              value={calledShowNumber}
              onChange={(e) => setCalledShowNumber(e.target.value)}
              placeholder="例如 057112345678（与阿里云真实号管理一致）"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">被叫手机号</Text>
            <Input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="例如 13811111111"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房产名</Text>
            <Input
              value={houseName}
              onChange={(e) => setHouseName(e.target.value)}
              placeholder="请输入房产名"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房间号</Text>
            <Input
              value={roomFang}
              onChange={(e) => setRoomFang(e.target.value)}
              placeholder="请输入房间号"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">剩余金额（播报时截断小数）</Text>
            <InputNumber
              min={0}
              step={1}
              style={{ width: '100%' }}
              value={amount}
              onChange={(v) => setAmount(v)}
              placeholder="请输入金额"
              disabled={sendLoading}
            />
          </div>
          <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 12 }}>
            使用库内 <Text code>voice_notify_tts_code_exclusive</Text> 专属 TTS；外显号仅本页传入，不改正式定时配置。
          </Paragraph>
          <Space wrap>
            <Button type="primary" loading={sendLoading} onClick={sendTest}>
              发送低电量语音测试
            </Button>
            <Button loading={queryLoading} onClick={() => loadToday()}>
              查询今日结果
            </Button>
          </Space>
        </Space>
      </Card>

      <Card title="今日外呼记录" size="small" style={{ maxWidth: 900 }}>
        {queryMsg ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 12 }}>
            {queryMsg}
          </Text>
        ) : null}
        <Table
          size="small"
          rowKey={(row) => String(row.queue_id || row.seq)}
          loading={queryLoading}
          dataSource={list}
          pagination={false}
          locale={{ emptyText: queryLoading ? '查询中…' : '今日暂无测试记录' }}
          columns={[
            { title: '序号', dataIndex: 'seq', width: 56 },
            { title: '时间', dataIndex: 'queued_at', width: 150 },
            { title: '房源', dataIndex: 'fang', ellipsis: true },
            { title: '发送', dataIndex: 'queue_status_text', width: 80 },
            {
              title: '接听结果',
              dataIndex: 'answer_label',
              render: (text, row) => (
                <Tag color={voiceAnswerTagColor(row.answer_status)} style={{ margin: 0 }}>
                  {text || '—'}
                </Tag>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default ExclusivePoolVoiceTest;
